import { getBusinessInsuranceProductSchemeMap } from '../../constants/quote';
export var judgeHideExtraProductEditInfoScheme = function judgeHideExtraProductEditInfoScheme(productSchemes) {
  return !!(productSchemes !== null && productSchemes !== void 0 && productSchemes.find(function (key) {
    return [getBusinessInsuranceProductSchemeMap().r2r.value, getBusinessInsuranceProductSchemeMap().uces.value].includes(key);
  }));
};
export var appendNewExtraHandleProductSchemeNewOnlyOneList = function appendNewExtraHandleProductSchemeNewOnlyOneList(list) {
  if (list.find(function (key) {
    return key === getBusinessInsuranceProductSchemeMap().r2r.value;
  })) {
    return [getBusinessInsuranceProductSchemeMap().r2r.value];
  } else if (list.find(function (key) {
    return key === getBusinessInsuranceProductSchemeMap().uces.value;
  })) {
    return [getBusinessInsuranceProductSchemeMap().uces.value];
  } else {
    return [];
  }
};